import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { ToggleableInputDirective } from './../shared';
import { provideValueAccessor } from './../../../utils/shared-utils';

@Component({
    providers: [provideValueAccessor(CheckboxComponent)],
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent extends ToggleableInputDirective{
  private _required = false;
  private _inverted = false;
  @ViewChild('input') inputElement!: ElementRef<HTMLInputElement>;

  @Input() ariaLabel?: string;
  @Input() ariaLabelledBy?: string;
  @Input() ariaChecked?: 'true' | 'false' | 'mixed';

  @Input()
  get required(): boolean {
    return this._required;
  }

  set required(value: boolean) {
    this._required = typeof value !== 'undefined' && value !== false;
  }

  @Input()
  get inverted(): boolean {
    return this._inverted;
  }

  set inverted(value: boolean) {
    this._inverted = typeof value !== 'undefined' && value !== false;
  }

  public focus(): void {
    if (this.inputElement?.nativeElement) {
      this.inputElement.nativeElement.focus();
    }
  }
}
